// Preserve the original ISO UTC contract for bicycle writes.
export function bikeDateTimeForApi(date = new Date()) {
  return date.toISOString();
}
